import {Project} from '../models/project.model';
import {User} from '../models/user.model';

export class SessionService {
  static isLoggedIn = false;
  static user: User = null;
  static selectedProject: Project = null;
  static apiToken: string = null;
}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/services/session.service.ts